export default "__VITE_ASSET__wK43p5mg__"